


// DoctorViewFilters.js

const PrescriptionViewFilters = {
  default: [
      {
    label: "Status",
    key: "status",
    options: ["Completed", "In Progress"],
  },

  {
    label: "Prescription Type",
    key: "prescriptionType",
    options: ["Standard", "Emergency", "Non-Standard"],
  }

  ],
  additional: [
  {
      label: "Date",
      key: "prescriptionDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default PrescriptionViewFilters;
